export enum Sizes {
  SMALL_SCREEN = 600,
  MIDDLE_SCREEN = 900,
  LARGE_SCREEN = 1024,
}
